import { SHIPPING_SPEED } from 'Pages/Requests/Enum';
import PropTypes from 'prop-types';
import styles from './Shipping.module.css';

const ShippingSpeedLabel = ({ shippingSpeedKey }) => {
  return (
    <div
      className={
        shippingSpeedKey === '2_NEXT_DAY'
          ? styles.shipping_speed_next_day
          : shippingSpeedKey === '1_TWO_DAY'
          ? styles.shipping_speed_two_day
          : styles.shipping_speed_label
      }>
      <span>{SHIPPING_SPEED[shippingSpeedKey]}</span>
    </div>
  );
};

ShippingSpeedLabel.propTypes = {
  shippingSpeedKey: PropTypes.string.isRequired,
};

export default ShippingSpeedLabel;
